/**
 * The Amazon Ads account the Shop list below belongs to.
 *
 * Shop selection is the first place a seller could wonder "which Amazon login
 * is this?" — especially when they manage several.
 */
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

interface AdsAccountCardProps {
  name: string;
  email?: string | null;
}

/** Initials from word boundaries: "HaHbHc-FitDirect" reads as "HF", not "HA". */
function initialsOf(name: string): string {
  const words = name.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}

export function AdsAccountCard({ name, email }: AdsAccountCardProps) {
  const { t } = useTranslation("auth");
  const accountType = t("selectProfile.accountType");

  return (
    <div className="flex items-center gap-2.5 rounded-[10px] border border-line bg-surface p-3">
      <span className="flex size-10 shrink-0 items-center justify-center rounded-[10px] bg-ink text-xs font-semibold text-canvas">
        {initialsOf(name)}
      </span>
      <span className="flex min-w-0 grow flex-col gap-0.5">
        <span className="flex items-center gap-2">
          <span className="truncate text-[13px] font-semibold leading-[18px] text-ink">{name}</span>
          <Badge variant="success" size="compact" className="shrink-0">
            {t("connectAmazon.connected")}
          </Badge>
        </span>
        <span className="truncate text-[11px] leading-[15px] text-muted-foreground">
          {email ? `${email} · ${accountType}` : accountType}
        </span>
      </span>
    </div>
  );
}
